module.exports = __webpack_public_path__ + "1_0_64/img/200 Big Ben 2.ff443c4b.jpg";